export const throwIfNotOK = (response: Response) => {
  if (!response.ok) {
    throw Error(`${response.statusText} ${response.status}`);
  }
  return response;
};
